
import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { TwilioConfigTab } from "./TwilioConfigTab";
import { ElevenLabsConfigTab } from "./ElevenLabsConfigTab";
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from "@/components/ui/card";
import { Phone, MessageSquare } from "lucide-react";

export function VoiceAgentConfig() {
  const [activeTab, setActiveTab] = useState("twilio");
  
  return (
    <Card className="border-2 border-primary/20 shadow-sm">
      <CardHeader className="bg-primary/5 pb-2">
        <CardTitle className="text-lg flex items-center">
          <Phone className="h-5 w-5 mr-2 text-primary" />
          Voice Agent Configuration
        </CardTitle>
        <CardDescription>
          Configure your AI phone screening capabilities and test your integration
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-4">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="mb-4 grid w-full grid-cols-2">
            <TabsTrigger value="twilio" className="flex items-center gap-1">
              <Phone className="h-4 w-4" />
              Twilio Phone
            </TabsTrigger>
            <TabsTrigger value="elevenlabs" className="flex items-center gap-1">
              <MessageSquare className="h-4 w-4" />
              ElevenLabs Voice
            </TabsTrigger>
          </TabsList>
          <TabsContent value="twilio">
            <TwilioConfigTab />
          </TabsContent>
          <TabsContent value="elevenlabs">
            <ElevenLabsConfigTab />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}
